import MultiTurbineSection7 from './MultiTurbineSection7';
import MultiTurbineSection6 from './MultiTurbineSection6';
import MultiTurbineSection5 from './MultiTurbineSection5';
import MultiTurbineSection4 from './MultiTurbineSection4';
import MultiTurbineSection3 from './MultiTurbineSection3';
import MultiTurbineSection2 from './MultiTurbineSection2';
import MultiTurbineSection1 from './MultiTurbineSection1';

export default function MultiTurbine() {
  return (
    <>
      <MultiTurbineSection1 /> 
      <MultiTurbineSection2 />
      <MultiTurbineSection3 />  
      <MultiTurbineSection4 />  
      <MultiTurbineSection5 />
      <MultiTurbineSection6 />
    </>
  );
}